import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { INotificationType } from 'libs/domain';
import { gateway } from 'libs/generated-grpc-web';
import { first } from 'lodash';
import { firstValueFrom } from 'rxjs';
import { $enum } from 'ts-enum-util';

import { NotificationActions } from '@app/src/app/store/Notifications/actions';
import { NotificationStoreModel } from '@app/src/app/store/Notifications/model';

import {
  SystemAlertCloseEvents,
  SystemAlertModalHangTime,
  SystemAlertModalService,
  SystemAlertModalType,
} from '@shared/components/system-alert-modal';

import { ScheduledReportsHistoryService } from '../../shared/services/scheduled-reports/scheduled-reports-history.service';

@Injectable({ providedIn: 'root' })
export class IdNotificationHandlerService {
  constructor(
    private _systemAlertModal: SystemAlertModalService,
    private _store: Store<any>,
    private _scheduledReportsHistoryService: ScheduledReportsHistoryService,
  ) {}

  public isIdNotification(type: string) {
    if (!type) return false;
    const idNotificationTypes = [INotificationType.ID_UPLOADS];

    return idNotificationTypes.includes($enum(INotificationType).asValueOrDefault(type, null));
  }

  public handleIdNotification(msg: gateway.notification_pb.Notification.AsObject) {
    const handlers = {
      [INotificationType.ID_UPLOADS]: this.handleIdUploadsNotification.bind(this),
    };

    const notification: NotificationStoreModel = { id: msg.notificationId };
    this._store.dispatch(new NotificationActions.MarkNotificationAsReadAction(notification));
    const notificationType = $enum(INotificationType).asValueOrDefault(msg.notificationType, null);

    if (handlers[notificationType]) {
      handlers[notificationType](msg);
    }
  }

  private async handleIdUploadsNotification(msg: gateway.notification_pb.Notification.AsObject) {
    const metadata = JSON.parse(msg.metadata || '{}');
    const failed = metadata.failed || false;
    const success = metadata.success || 0;
    const reportId = metadata.reportId || null;
    const modalType = failed ? SystemAlertModalType.ERROR : SystemAlertModalType.SUCCESS;
    const message = failed
      ? 'An error occurred during the upload process'
      : `${success} photos were successfully uploaded`;

    const modalRef = await this._systemAlertModal.open({
      modalType,
      heading: msg.title,
      message,
      hangTime: SystemAlertModalHangTime.LONG,
      detailedMessage: failed
        ? [
            ['Successful uploads', metadata.success],
            ['Failed uploads', failed],
          ]
        : undefined,
      confirmActionBtn: failed && reportId ? 'Download report' : '',
      closeBtn: failed && reportId ? 'Cancel' : 'Close',
    });

    const response = await firstValueFrom(modalRef.afterClosed());

    // user wants to download the error report
    if (response.type === SystemAlertCloseEvents.CONFIRM) {
      try {
        await this._scheduledReportsHistoryService.downloadErrorReport(reportId);
      } catch (error) {}
    }
  }
}
